"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recommendation = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _offerStyles = require("./offer-styles");

var _baseReactComponents = require("@navinc/base-react-components");

var _detailsTabs = require("../common/details-tabs");

var _details = require("./details");

var _jsxRuntime = require("react/jsx-runtime");

var RecommendationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "RecommendationWrapper",
  componentId: "sc-435ld0-0"
})(["&&{> *{margin:24px 0;}}"]);

var RecommendationTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "RecommendationTitle",
  componentId: "sc-435ld0-1"
})(["margin-bottom:8px;"]);
var PreLineCopy = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "PreLineCopy",
  componentId: "sc-435ld0-2"
})(["white-space:pre-line;"]);

var Recommendation = function Recommendation(_ref) {
  var _loanOffer$descriptio, _loanOffer$navEditori, _loanOffer$navEditori2;

  var loanOffer = _ref.loanOffer,
      shownTab = _ref.shownTab,
      handleShownTab = _ref.handleShownTab;
  var title = _details.OUR_RECOMMENDATION;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_detailsTabs.MobileTab, {
      title: title,
      shownTab: shownTab,
      handleShownTab: handleShownTab
    }), title === shownTab && /*#__PURE__*/(0, _jsxRuntime.jsxs)(RecommendationWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PreLineCopy, {
        children: (_loanOffer$descriptio = loanOffer.description) !== null && _loanOffer$descriptio !== void 0 ? _loanOffer$descriptio : ''
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_offerStyles.WithIconWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "feedback/thumbs-up",
          color: _baseReactComponents.theme.mermaidGreen500
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RecommendationTitle, {
            bold: true,
            children: "Our recommendation"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PreLineCopy, {
            children: (_loanOffer$navEditori = (_loanOffer$navEditori2 = loanOffer.navEditorial) === null || _loanOffer$navEditori2 === void 0 ? void 0 : _loanOffer$navEditori2.recommendation) !== null && _loanOffer$navEditori !== void 0 ? _loanOffer$navEditori : ''
          })]
        })]
      })]
    })]
  });
};

exports.Recommendation = Recommendation;
//# sourceMappingURL=recommendation.js.map